export const moneyFormatter = Intl.NumberFormat('en-us', {
  //@ts-ignore
  notation: 'compact',
  compactDisplay: 'short',
});

export const numberFormatter = Intl.NumberFormat('en-us', {});
